import clsx from 'clsx';
import { FC, Fragment } from 'react';
import { isMobile } from '../../utils/common';

const Skeleton: FC = () => {
    const isMob = isMobile();

    return (
        <div
            className={clsx(
                'bg-white',
                isMob ? 'gap-10 p-20 pb-10' : 'gap-20 p-30 pt-20 border border-charcoal-100 rounded-20',
            )}
        >
            <h4 className='animate-pulse h4 font-medium w-fit text-charcoal-80 bg-charcoal-80 rounded-5'>
                Quick Guide
            </h4>
            <div className={clsx(isMob ? 'flex flex-col' : 'grid grid-cols-3 gap-30 pt-20')}>
                {Array.from({ length: 8 }).map((_, i) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <Fragment key={i}>
                        <li
                            className={clsx(
                                'animate-pulse flex gap-10 group list-sm',
                                isMob ? 'items-center relative p-0 py-15' : 'flex-col',
                            )}
                        >
                            <div className='w-40 h-40 bg-charcoal-80 rounded-10' />
                            {isMob ? (
                                <>
                                    <div className='flex flex-col flex-auto pt-1 pb-5 group-[.list-sm]:py-[1px] text-charcoal-80 bg-charcoal-80 rounded-10'>
                                        <p className='body-md flex group-[.list-lg]:body-lg'>Account Settings</p>
                                        <p className='body-sm'>Update email, phone no. or password</p>
                                    </div>
                                    <div className='w-6 h-6 bg-charcoal-80 rounded-5' />
                                </>
                            ) : (
                                <>
                                    <p className='body-md font-medium text-charcoal-80 bg-charcoal-80 rounded-5'>
                                        Account Settings
                                    </p>
                                    <p className='body-sm text-charcoal-80 bg-charcoal-80 rounded-5'>
                                        Update email, phone no. or password
                                    </p>
                                </>
                            )}
                        </li>
                        {isMob && i !== 7 && (
                            <div className='animate-pulse self-end w-[calc(100%-50px)] h-px bg-charcoal-80 rounded-5' />
                        )}
                    </Fragment>
                ))}
            </div>
        </div>
    );
};

export default Skeleton;
